import { CheckMark, Sync } from '@lyearn/icons';

import { SavingStates } from './enums';

export const SAVING_STATE_CONFIG = {
  [SavingStates.Saving]: { labelKey: 'Common:Actions.Saving', Icon: Sync },
  [SavingStates.Saved]: { labelKey: 'Common:Actions.ChangesSaved', Icon: CheckMark },
};
